import { gql } from 'graphql-tag';

export const PAYABLES_COUNT_QUERY = gql`
  query Idb5c4de770b0bf8223855e600b7fb3ed0(
    $companyId: ID!
    $filtersV2: JSON
    $textualSearch: String
  ) {
    __typename
  }
`;

export type RawResult = {
  company: {
    payables: {
      totalCount: number;
    };
  };
};
